import * as angular from 'angular';

export class DocumentsService {
    private apiRoot: string = '/api/v1/documents';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    updateFileTitle(id, value) {
        return this.$http.patch(
            `${this.apiRoot}/${id}/`,
            { title: value }
        );
    }

    deleteFile(id) {
        return this.$http.delete(
            `${this.apiRoot}/${id}/`
        );
    }
}

angular
    .module('app')
    .service('DocumentsService', DocumentsService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/documents.factory.ts